import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { TuiSvgModule } from '@taiga-ui/core';
import { ShopContact } from '@us/web/shared/data-access';
import { selectShopContact } from '@us/web/shop/data-access';
import { Observable } from 'rxjs';

@Component({
    selector: 'us-contact',
    standalone: true,
    imports: [CommonModule, TranslocoModule, IonicModule, TuiSvgModule],
    templateUrl: './contact.page.html',
    styleUrls: ['./contact.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactPage {
    private readonly store = inject(Store);

    readonly contactInfo$: Observable<ShopContact> = this.store.select(selectShopContact);
}
